import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { useShop } from "@/lib/shop";

export const BuyButton = ({ role, installment = false, children, className = "", testId }) => {
  const { buy } = useShop();
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    setBusy(true);
    await buy(role, { installment });
    setBusy(false);
  };
  return (
    <button type="button" onClick={onClick} disabled={busy} data-testid={testId || `buy-${role}${installment ? "-installment" : ""}-button`}
      className={`btn-cta disabled:opacity-70 ${className}`}>
      {children}
      {busy ? <Loader2 size={18} className="animate-spin" /> : <ArrowRight size={18} />}
    </button>
  );
};
